import { categoryStats, testimonials } from "@/mocks/news";

const ROLE_MAP: Record<string, string> = {
  primary: "text-primary-600",
  accent: "text-accent-600",
  secondary: "text-secondary-600",
};

const PRINCIPLES = [
  { icon: "ri-eye-off-line", title: "不追隐私", text: "聚焦公开可讨论的现场与话题，不窥探、不曝光他人私生活。" },
  { icon: "ri-focus-3-line", title: "先核实再说", text: "涉及人物与事件先查信源，标注时间与归属，拿不准就写“跟进中”。" },
  { icon: "ri-leaf-line", title: "清爽不标题党", text: "拒绝耸动标题与低质流量，让每一次点开都有实际信息含量。" },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="rounded-3xl bg-background-100 p-6 md:p-10">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
            {/* brand intro */}
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
                <i className="ri-quill-pen-line text-sm w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
                关于瓜场
              </span>
              <h2 className="mt-3 text-2xl font-bold text-foreground-950 md:text-3xl">做一本随时可翻的“城市热事速览”</h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-[15px]">
                瓜场是一份面向中文读者的热点快讯聚合读物，专注整理娱乐现场、城市新鲜事、消费观察、民生趣闻与出行生活等话题。我们相信，
                “吃瓜”不该只是围观热闹，更该是高效、可靠地了解大家在聊什么、身边正在发生什么。
              </p>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-[15px]">
                因此，编辑部全天滚动更新，用简洁的标题、清晰的分类与准确的时间标注，把纷繁的信息整理成你能随手读完的短讯。我们坚持克制与分寸，
                不追隐私、不放大冲突，让热点回归信息本身。
              </p>

              {/* principles */}
              <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-3">
                {PRINCIPLES.map((p) => (
                  <div key={p.title} className="rounded-xl bg-background-50 p-4">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                      <i className={`${p.icon} text-lg w-5 h-5 flex items-center justify-center`} aria-hidden="true"></i>
                    </span>
                    <h3 className="mt-3 text-sm font-bold text-foreground-950">{p.title}</h3>
                    <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{p.text}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* stats + testimonials */}
            <div>
              <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
                {categoryStats.map((s) => (
                  <div key={s.label} className="rounded-xl border border-background-200 bg-background-50 p-4 text-center">
                    <p className={`text-2xl font-bold ${ROLE_MAP[s.role]}`}>{s.value}</p>
                    <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
                  </div>
                ))}
              </div>

              <h3 className="mt-7 text-base font-bold text-foreground-950">读者怎么说</h3>
              <div className="mt-4 space-y-3">
                {testimonials.map((t) => (
                  <figure key={t.name} className="rounded-xl border border-background-200 bg-background-50 p-4">
                    <blockquote className="text-sm leading-relaxed text-foreground-800">“{t.quote}”</blockquote>
                    <figcaption className="mt-3 flex items-center gap-2 text-xs text-foreground-600">
                      <span className="flex h-7 w-7 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                        {t.name.charAt(0)}
                      </span>
                      <span className="font-medium text-foreground-800">{t.name}</span>
                      <span aria-hidden="true">·</span>
                      <span>{t.role}</span>
                    </figcaption>
                  </figure>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}